import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c2ea9bf0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea9bf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ea9bf0')) {
      api.createRecord('c2ea9bf0', component.options)
    } else {
      api.reload('c2ea9bf0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c2ea9bf0&scoped=true", function () {
      api.rerender('c2ea9bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/verify/plan/index.vue"
export default component.exports